export default {"src":"/_next/static/media/pleasers.71a9d7ce.svg","height":24,"width":146};